<template>
  <div>
    <div class="footer1">
        <img :src='$t("logo.footer")' alt="Logo iwim">
    </div>
    <div class="Footer">
      <p>{{ $t("layout.Copyright") }}</p>
    </div>
  </div>
</template>